import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DriveFileRenameOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drive_file_rename_outline"}/>
}
